module.exports = __webpack_public_path__ + "img/1.a82c48d3.jpg";